import type { ConfirmationOptions } from 'primevue/confirmationoptions';
import { useConfirm } from 'primevue/useconfirm';

import { useDevice } from '../device';

export interface ConfirmOptions extends ConfirmationOptions {
  event?: Event;
  group?: 'confirmDialog' | 'confirmPopup' | 'confirmPopupPaymentSystemReview' | 'confirmDialogPaymentSystemReview';
}

interface ConfirmDialogsComposable {
  confirmDelete(options: ConfirmOptions): void;
  confirmEdit(options: ConfirmOptions): void;
  confirm(options: ConfirmOptions): void;
}

export default function useConfirmDialogs(): ConfirmDialogsComposable {
  const confirmService = useConfirm();
  const { isMobile } = useDevice();

  function confirm(options: ConfirmOptions): void {
    const {
      event,
      target,
      group,
      ...restOptions
    } = options;
    const eventTarget = target ?? event?.currentTarget as HTMLElement;

    confirmService.require({
      icon: 'pi pi-question-circle',
      acceptIcon: 'pi pi-check-circle',
      acceptProps: {
        severity: 'success',
      },
      rejectClass: 'p-button-outlined',
      group: group || (eventTarget && !isMobile.value ? 'confirmPopup' : 'confirmDialog'),
      blockScroll: isMobile.value,
      target: eventTarget,
      defaultFocus: 'no',
      ...restOptions,
    });
  }

  function confirmDelete(options: ConfirmOptions): void {
    confirm({
      ...options,
      acceptProps: {
        ...options.acceptProps,
        severity: 'danger',
      },
    });
  }

  function confirmEdit(options: ConfirmOptions): void {
    confirm(options);
  }

  return {
    confirm,
    confirmDelete,
    confirmEdit,
  };
}
